const baseURL = process.env.BASE_URL || process.env.NEXT_PUBLIC_BASE_URL || ''
const SLASH = '/'

const UrlModel = {
  fullURL: (path: string) => {
    if (path.startsWith(SLASH)) {
      return baseURL + path
    }

    return [baseURL, path].join(SLASH)
  },
  generatePath: (pathname: string, queryParams: Record<string, string>): string => {
    const params = new URLSearchParams(queryParams)

    return [pathname, params].filter(Boolean).join('?')
  },
}

export default UrlModel
